window.financeVideoOverlay = function financeVideoOverlay() {
    $('.js_financeVideoOverlay').mtcOverlay({
        buttonHtml: '<div class="videoCloseButton overlayCloseButton"><a href="#"><i class="fa fa-remove"></i> Close</a></div>',
        onOpen: function () {
            $('.overlayBox').addClass('financeVideoOverlayBox');
        }
    });
};

$(document).ready(function () {
    "use strict";

    financeVideoOverlay();
});